document.addEventListener("turbo:load", function () {
  const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  //const manifests = document.querySelectorAll('link[rel="manifest"]');
  // const favicons = document.querySelectorAll('.js-favicon[rel="icon"]');
  const themeColor = document.querySelector('meta[name="theme-color"]');

  const toggleTheme = () => {
    const darkModeOn = darkModeMediaQuery.matches ? true : false;
    //manifests.forEach((link) => {
    //  link.href = darkModeOn ? link.dataset.hrefDark : link.dataset.hrefLight;
    //});
    // favicons.forEach((link) => {
    //   link.href = darkModeOn ? link.dataset.hrefDark : link.dataset.hrefLight;
    // });
    if (themeColor) themeColor.content = darkModeOn ? "black" : "white";
  };
  darkModeMediaQuery.addListener(toggleTheme);
  toggleTheme();
});
